import { currentRefinements } from 'instantsearch.js/es/widgets';

export default function CurrentRefinements(container = '#current-refinements', cssClasses = {}) {
	return currentRefinements({
		container,
		cssClasses,
		transformItems(items) {
			return items;
		},
	});
}
